// Check for partner routes and attach x-tenant-key
// composables/useApplyPartnerHeaders.js
export const usePartnerHeaders = (fetchOptions = {}) => {
	const runtimeconfig = useRuntimeConfig()
	const { partnerName } = useGetPartnerName()
	const partner = partnerName.value

	let tenantKey = ''

	// 1. Determine the correct tenant key based on the partner route
	if (partner === 'carsales') {
		tenantKey = runtimeconfig.public.X_SITE_TENANT_CARSALES
	} else if (partner === 'erinliving') {
		tenantKey = runtimeconfig.public.X_SITE_TENANT_ERIN_LIVING
	}

	// 2. Safely attach it to the headers object if it exists
	if (tenantKey) {
		fetchOptions.headers = {
			...fetchOptions.headers,
			'X-Site-Tenant': tenantKey,
		}
	}

	return fetchOptions
}
